import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const StatsSection = styled.section`
  padding: 80px 56px;
  background: ${({ theme }) => theme.colors.bg};
  border-top: 1px solid ${({ theme }) => `rgba(${theme.colors.textRgb},0.08)`};
  border-bottom: 1px solid ${({ theme }) => `rgba(${theme.colors.textRgb},0.08)`};

  @media (max-width: 768px) {
    padding: 60px 20px;
  }
`;

const Container = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const StatItem = styled(motion.div)`
  padding: 32px 24px;
  text-align: center;
  border-right: 1px solid ${({ theme }) => `rgba(${theme.colors.textRgb},0.08)`};

  &:last-child {
    border-right: none;
  }

  @media (max-width: 768px) {
    &:nth-child(2) {
      border-right: none;
    }
    &:nth-child(3) {
      border-right: 1px solid ${({ theme }) => `rgba(${theme.colors.textRgb},0.08)`};
    }
    border-bottom: 1px solid ${({ theme }) => `rgba(${theme.colors.textRgb},0.08)`};
    &:nth-child(3), &:nth-child(4) {
      border-bottom: none;
    }
  }
`;

const StatNumber = styled.div`
  font-family: 'Fraunces', 'Times New Roman', Georgia, serif;
  font-size: clamp(40px, 5vw, 64px);
  font-weight: 500;
  letter-spacing: -0.04em;
  line-height: 1;
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 8px;

  span {
    color: #FF5B3A;
  }
`;

const StatLabel = styled.p`
  font-family: 'DM Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.text.muted};
  margin: 0;
`;

const stats = [
  { number: '50', suffix: '+', label: 'Projects delivered' },
  { number: '10', suffix: 'M+', label: 'Users reached' },
  { number: '98', suffix: '%', label: 'Client satisfaction' },
  { number: '8', suffix: '+', label: 'Years in market' },
];

const Stats = () => (
  <StatsSection>
    <Container>
      <StatsGrid>
        {stats.map((stat, i) => (
          <StatItem
            key={i}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
          >
            <StatNumber>
              {stat.number}<span>{stat.suffix}</span>
            </StatNumber>
            <StatLabel>{stat.label}</StatLabel>
          </StatItem>
        ))}
      </StatsGrid>
    </Container>
  </StatsSection>
);

export default Stats;
